module.exports = __webpack_public_path__ + "media/images/icons/twitter-light-99232739789d8c88433917363441c8cf.png";